// -------------------------------------------//
//              Directive Favorite
// -------------------------------------------//
// Little Star close to a datapoint

angular.module('app.directives.favorite', []).//
directive('favoriteBox', ['xcenterUtils','xCenterConfig','$state','conf_guidEmpty','$timeout','__Favorite','controlledBySceneModal','API','f_User','f_Info','selectIconModal','temperatureFunctionsService',
    function (xcenterUtils,xCenterConfig,$state,conf_guidEmpty,$timeout,__Favorite,controlledBySceneModal,API,f_User,f_Info,selectIconModal,temperatureFunctionsService) {
        var obj = {
            link: function (scope, element, attrs) {
                scope.Favorite = scope.model;

                function colorPickerDetected(datapointConfig) {
                    if (datapointConfig.$UI && datapointConfig.$UI.Type === 'ColorPicker') {
                        return true;
                    }
                    return false;
                }


                scope.getBoxUrl = function () {
                    var fileName, o, state;

                    o = {};
                    if(scope.config.editMode){
                        return 'views/favoriteBox/favoriteBox.editMode.html';
                    }
                    if(scope.config.sortMode){
                        return 'views/favoriteBox/favoriteBox.sortMode.html';
                    }

                    switch (scope.model.$UI.FavoriteType) {
                        case "MenuEntry":
                            fileName = 'favoriteBoxMenuEntry.html';
                            scope.classes = 'favoriteBoxMenuEntry';
                             state = 'device.entry';

                             o = { 'deviceId' : scope.model.DeviceId, 'menuEntryId' : scope.model.MenuEntryId};
                            break;
                        case "Device":
                            fileName = 'favoriteBoxDevice.html';
                            scope.classes = 'favoriteBoxDevice';
                            o = { deviceId : scope.model.DeviceId, menuEntryId : conf_guidEmpty};
                            state = 'device.entry';

                            break;

                        case "Datapoint":
                            if (colorPickerDetected(scope.model.Datapoint.DatapointConfig)) {
                                fileName = 'favoriteBoxColorPicker.html';
                                scope.classes = 'favoriteBoxColorPicker';
                            }
                            else if (scope.model.Datapoint.DatapointConfig.canWrite) {
                                fileName = 'favoriteBoxDatapointWrite.html';
                                scope.classes = 'favoriteBoxDatapointWrite';
                            } else {
                                fileName = 'favoriteBoxDatapointRead.html';
                                scope.classes = 'favoriteBoxDatapointRead';
                            }

                            break;
                        case "Scene":
                            // Todo: Switch between SceneTypes
                            if(scope.model.FavoriteSceneType == 0){
                                fileName = 'favoriteBoxSceneExecute.html';
                                scope.classes = 'favoriteBoxSceneExecute';
                            }else{
                                fileName = 'favoriteBoxSceneOnOff.html';
                                scope.classes = 'favoriteBoxSceneOnOff';
                            }

                            scope.model.IsDisabled = !scope.model.Enabled;

                            break;
                        case "CustomAction":
                            fileName = 'favoriteBoxCustomAction.html';
                            scope.classes = 'customAction';
                            o = { 'deviceId': scope.model.DeviceId, 'menuEntryId': scope.model.MenuEntryId };
                            if(xCenterConfig.customActions.hasOwnProperty(scope.model.CustomActionName))
                            {
                                state = xCenterConfig.customActions[ scope.model.CustomActionName ].state;
                                o.deviceId = scope.model.DeviceId;
                                if(scope.model.CustomActionName === 'DevicesManagementWithFilter')
                                {
                                    o.filterButton = false;
                                }
                                o = angular.extend(o,xCenterConfig.customActions[ scope.model.CustomActionName ].stateParams);
                                //alert(state);
                            }else{
                                state = 'device.entry';
                            }
                            if(scope.model.UITags && scope.model.UITags._values && scope.model.UITags._values.length > 0)
                            {

                                for(var i = 0; i < scope.model.UITags._values.length; i++)
                                {
                                    var tag = scope.model.UITags._values[i];
                                    tag  = tag.split(':');

                                    switch(tag[0])
                                    {
                                        case "DeviceTypeFilter":
                                            o.deviceTypeFilter =  tag[1].replace(/[|,]/g,',');

                                            break;
                                        case "MenuEntryFilter":
                                             o.menuEntryFilter =  tag[1].replace(/[|,]/g,',');
                                            //alert( o.menuEntryFilter);
                                            break;
                                    }
                                }
                                // Parse incoming filter
                                // DeviceFilter
                                // MenuEntryFilter
                            }
                            break;
                        default:
                            fileName = 'favoriteBoxDefault.html';
                            if( scope.model.hasOwnProperty ('MenuEntryId') )
                            {

                                o = { deviceId : scope.model.DeviceId, menuEntryId : scope.model.MenuEntryId};
                                state = 'device.entry';
                            }
                    }
                    o.object = scope.model;
                    o.favorite = scope.model;
                    scope.infoStyle = '';
                    scope.model.$UI.toState = state;
                    scope.model.$UI.toStateParam = o;
                    return 'views/favoriteBox/' + fileName;
                }
            },
            templateUrl: 'views/favoriteBox/favoriteBox.html',
            scope: {
                model: '=model',
                config: '=config'
            },

            /* @ngInject */
            controller: function ($scope) {


                $scope.deviceDatapointCallbacks = {
                    onWrite : function(Datapoint){
                        $scope.to = $timeout(
                            $scope.finishControlDatapoint
                        ,600);
                    },
                    onStart : function(Datapoint)
                    {
                        $timeout.cancel($scope.to);
                    }
                };

                function resetLongPress(Favorite) {
                    if(Favorite.$UI.longPressed) {
                        Favorite.$UI.longPressed = undefined;
                        return true;
                    }
                    return false;
                }

                $scope.favoriteBoxClass = function () {
                    return $scope.classes;
                }
                $scope.canDelete = function(){
                    return  $scope.Favorite.UserLevelWrite <= f_User.getUserLevel();
                }
                $scope.canWrite = function(){
                    return  $scope.canDelete();
                }
                $scope.writeIt = function(){
                    return '!!'+f_User.getUserLevel();
                }
                $scope.canMove = function(){
                    return  $scope.Favorite.UserLevelWrite <= f_User.getUserLevel();
                }
                $scope.markForDelete = function(event){
                    if(!$scope.canDelete())
                    {
                        f_Info.addInfo({Title:'ERROR_TITLE_LowUserlevel',Content:'ERROR_CONTENT_LowUserlevel'});
                        return;
                    }
                    event.stopPropagation();
                    $scope.Favorite.$UI.markForDelete = true;
                }
                $scope.clickFavorite = function () {
                    if($scope.preventNavigationClick){ return; };
                    if (resetLongPress($scope.Favorite)) { return; }

                    if ($scope.config && $scope.config.editMode == true) {

                        if(!$scope.canWrite()){ return; };
                        if ($scope.config.editItemBefore && $scope.config.editItem && xcenterUtils.wasEdited($scope.config.editItemBefore, $scope.config.editItem, ['DisplayName', 'Position', 'ImageName', 'ShowOnStartScreen'])) {
                            $scope.config.editItem.$UI.changed = true;
                        }
                        if ($scope.config.editItem != undefined && $scope.config.editItem.FavoriteId != $scope.Favorite.FavoriteId) {

                            $scope.config.editItem.$UI.editMode = false;
                        }
                        if ($scope.Favorite.$UI.editMode == true) {
                            $scope.Favorite.$UI.editMode = false;
                        } else {
                            $scope.Favorite.$UI.editMode = true;
                            $scope.config.editItem = $scope.Favorite;
                            $scope.config.editItemBefore = angular.copy($scope.Favorite);

                            $scope.Favorite.$UI.editMode = true;
                        }
                    } else {

                        var notAllowed = ['Datapoint', 'Scene'];
                        if (notAllowed.indexOf($scope.model.$UI.FavoriteType) === -1) {
                           // alert('go!'+$scope.Favorite.$UI.toState);
                            if($scope.model.$UI.toState){

                                $state.go($scope.Favorite.$UI.toState,$scope.Favorite.$UI.toStateParam);
                            }

                            //$scope.navigate();
                        }
                    }


                }


                $scope.hasWindowOpen = function (list) {
                    if (!list) {
                        return false;
                    }

                    for (var i = 0; i < list.length; i++) {
                        if (list[i].DatapointValue.Value === false) {
                            return true;
                        }
                    }
                    return false;
                }
                $scope.hasActivePlugActive = function (list) {
                    if (!list) {
                        return false;
                    }

                    for (var i = 0; i < list.length; i++) {
                        if (list[i].DatapointValue.Value === true) {
                            return true;
                        }
                    }
                    return false;
                }

                $scope.controlDatapoint = function(dp){
                    if(dp.DatapointConfig.canWrite){
                        $scope.preventNavigationClick = true;
                        $scope.selectedDatapoint = dp;
                    }else{
                        $scope.clickFavorite();
                    }

                }
                $scope.finishControlDatapoint = function(dp){
                    $scope.preventNavigationClick = false;
                    $scope.selectedDatapoint = null;
                }

                /* Scene Favorite */
                $scope.enableDisableScene = function(args,promise) {
                    if (resetLongPress($scope.Favorite)) { return; }

                    //$scope.Favorite.$UI.Scene.Enabled = !$scope.Favorite.$UI.Scene.Enabled;
                    $scope.Favorite.$UI.Scene.$enableDisable().$then(function(){
                        $scope.Favorite.IsDisabled = !$scope.Favorite.IsDisabled;
                        $scope.Favorite.Enabled = !$scope.Favorite.Enabled;
                    });
                }
                $scope.executeScene = function ( Favorite ) {
                    if (resetLongPress(Favorite)) { return; }

                    var _API = new API();
                    _API.Scene.ExecuteScene({SceneId:Favorite.SceneId}).$promise.then(function(data){
                        Favorite.$UI.ActionIsRunning = true;
                        Favorite.$UI.kickedOff = true;
                        var tempIcon = Favorite.ImageName;
                        $timeout(function () {
                            __Favorite.$byId(Favorite.FavoriteId).$then(function(data){
                                Favorite.ActionIsRunning = data.ActionIsRunning;
                            });
                            Favorite.ImageName = tempIcon;
                            Favorite.$UI.kickedOff = false;
                        }, 3000);
                    },function(){
                        Favorite.$UI.isPlaying = 'error';
                        $timeout(function () {
                            Favorite.isPlaying = false;
                        }, 3000);
                    })



                };
                $scope.showScenesForDatapoint = function (DeviceId, Datapoint, Favorite) {
                    if (resetLongPress(Favorite)) { return; }

                    if(!DeviceId){
                        DeviceId = {DeviceId:DeviceId};
                    }
                    controlledBySceneModal({Device:{DeviceId: DeviceId}, Datapoint:Datapoint});
                }

                $scope.changeIcon = function (Favorite,event) {
                    event.preventDefault();
                    event.stopPropagation();
                    selectIconModal( Favorite.ImageName ).then(function(modal){
                        modal.close.then(function(data){

                            if(data){
                                Favorite.ImageName = data;
                                Favorite.$UI.changed = true;
                                $scope.$broadcast('ImageNameChanged');
                            }
                        })
                    });
                };

                $scope.selectCorrectTemperature = function(actualTempArr) {
                    return temperatureFunctionsService.selectCorrectTemperature(actualTempArr);
                };

                //
            },

        };
        return obj;
    }])
    .directive('favorite', ['f_Favorites',
    function (f_Favorites) {
        var obj = {
            scope: {
                // new
                ngModel: '=ngModel',
                ngType: '@ngType'
            },

            link: function (scope, element, i, ctrl) {

                var checkForFavorite = function()
                {
                    var Fav = f_Favorites.objectHasFavorite(scope.ngModel, scope.ngType);
                    if (Fav) {
                        scope.ngModel.$UI.Favorite = Fav;
                    }else{
                        delete scope.ngModel.$UI.Favorite;
                    }
                }
                scope.$watch('ngModel', function () {
                    if (angular.isDefined(scope.ngModel)) {

                        checkForFavorite();
                    }
                });

                scope.$on('favorites-update',function(){
                    checkForFavorite();
                })
                scope.$on('favorites-add',function(){
                    checkForFavorite();
                })
                scope.$on('favorites-remove',function(){
                    checkForFavorite();
                })
            }
        };
        return obj;
    }]);
